import { createIcon } from './create-icon';

export const LockIcon = createIcon(
  'LockIcon',
  <>
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0110 0v4" />
    <circle cx="12" cy="16" r="1.5" />
    <path d="M12 17.5v1.5" />
  </>,
);
